/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    xander<luoxingzhang@frippler.com>
  | @Title:     快速入门
  | @Version:   2021-04-16  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function loadEquipModelApi(data) {
  return request({
    url: '?c=demo&a=equip&do=loaddev',
    method: 'post',
    data
  })
}

export function getDemoEquipApi(params) {
  return request({
    url: '?c=demo&a=equip&do=get',
    method: 'get',
    params
  })
}
